// extracted by css-extract-rspack-plugin
export default {"OptionsCardsBox":"opportunity-form-type-step_OptionsCardsBox__6Q0vX"};